import { SECONDS_TO_MS_RATIO } from 'services/helpers/formatTime';
import { Timer } from 'shared-types/lyrics';

import { FADE_OUT_DURATION_IN_S } from './Timer.style';
import { MENTION_SLIDE_END_TIME_IN_SECONDS } from '../MentionSlide/MentionSlide.utils';

export const getTimerProgressPercentage = (
  currentTimeInMs: number,
  timerStartTimeInMs: number,
  timerEndTimeInMs: number,
): number => {
  if (timerStartTimeInMs === timerEndTimeInMs) return 0;
  return ((currentTimeInMs - timerStartTimeInMs) / (timerEndTimeInMs - timerStartTimeInMs)) * 100;
};

export const shouldDisplayCurrentTimer = (
  currentTimer: Timer | null,
  currentTimeInMs: number,
): boolean => {
  if (!currentTimer) return false;

  // Timer should be hidden until the mention slide disappears
  if (currentTimeInMs < MENTION_SLIDE_END_TIME_IN_SECONDS * SECONDS_TO_MS_RATIO) return false;

  // Timers should be entirely hidden when currentTime === timerEnd
  // This helper switches the `isVisible` props before timerEnd, so
  // the fade out animation ends in sync with the timer end
  return currentTimeInMs < currentTimer.timerEnd - FADE_OUT_DURATION_IN_S * SECONDS_TO_MS_RATIO;
};

export const findCurrentTimer = (timers: Timer[], currentTimeInSeconds: number): Timer | null => {
  const currentTimeInMs = currentTimeInSeconds * SECONDS_TO_MS_RATIO;

  for (const timer of timers) {
    // timers are ordered by start time, so we stop searching
    // when timer startTime is greater than currentTime
    if (timer.timerStart > currentTimeInMs) break;

    if (isCurrentTimeInTimer(timer, currentTimeInMs)) {
      return timer;
    }
  }

  return null;
};

const isCurrentTimeInTimer = (timer: Timer, currentTimeInMs: number): boolean =>
  timer.timerStart <= currentTimeInMs && currentTimeInMs <= timer.timerEnd;
